import React from 'react';
import { Plus, FileText, Calculator, List, CheckCircle } from 'lucide-react';
import { clsx } from 'clsx';

const questionTypeIcons = {
  text: FileText,
  math: Calculator,
  'multiple-choice': List,
  'true-false': CheckCircle
};

const QuestionLibraryCard = ({ question, onInsert, context }) => {
  const Icon = questionTypeIcons[question.type] || FileText;

  return (
    <div className="border border-gray-200 rounded-lg p-4 hover:border-sigma-300 transition-colors">
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <div className="flex items-center space-x-2 mb-1">
            <Icon className="w-4 h-4 text-sigma-600 flex-shrink-0" />
            <span className="text-xs text-gray-500 capitalize">
              {question.type?.replace('-', ' ') || 'text'}
            </span>
            {question.points && (
              <span className="text-xs text-gray-400">
                {question.points} {question.points === 1 ? 'pt' : 'pts'}
              </span>
            )}
          </div>
          <h4 className="text-sm font-medium text-gray-900 truncate">
            {question.title || 'Untitled Question'}
          </h4>
          {question.content && (
            <p className="text-xs text-gray-500 mt-1 line-clamp-2">
              {question.content}
            </p>
          )}
        </div>
        <button
          onClick={onInsert}
          className="ml-3 flex-shrink-0 inline-flex items-center px-2 py-1 text-xs font-medium text-sigma-600 bg-sigma-50 rounded hover:bg-sigma-100 transition-colors"
        >
          <Plus className="w-3 h-3 mr-1" />
          Insert
        </button>
      </div>
    </div>
  );
};

export default QuestionLibraryCard;
